import { requestWithToken } from '../utilities/request';

const path = '/api/private/';

const get = (company_id, param) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`/companies/${company_id}/prime_greenfile_setting`),
    params: param,
  });
};

const update = (company_id, param) => {
  return requestWithToken({
    method: 'PATCH',
    url: path.concat(`/companies/${company_id}/prime_greenfile_setting`),
    data: param,
  });
};

export const PrimeGreenFileSettingService = {
  get,
  update,
};



// WEBPACK FOOTER //
// ./src/services/PrimeGreenFileSetting.js